<div style="width: 100%;">
  <mat-card class="box">
    <div class="divtitle">
      <span class="flex-container" style="padding: 8px;">
        <h1 class="label">{{'faq.label' |transloco}}</h1>
      </span>
    </div>
  </mat-card>
</div>

<div style="width: 100%;">
  <mat-card class="box">
    <div class="faq-container">
      <div *ngFor="let item of faqItems" class="faq-item">
        <button type="button" class="faq-question" (click)="toggleAnswer(item)" [attr.aria-expanded]="item.showAnswer">{{ item.question }}<mat-icon>{{ item.showAnswer ? 'remove' : 'add' }}</mat-icon></button>
        <div class="faq-answer" [ngStyle]="{'display': item.showAnswer ? 'block' : 'none'}">
          {{ item.answer }}
        </div>
      </div>
    </div>
  </mat-card>
</div>
